import { CardContent, DialogContent, DialogTitle } from '@mui/material';
import { useConfig, useNotification, useOidcWithAdmin } from '@revenuewell/front-end-bundle';
import moment from 'moment';
import { FC, useEffect, useMemo, useState } from 'react';
import { usePatientProfile } from '../../../../../../../hooks/use-patient-profile';
import AppointmentService from '../../../../../../../services/appointment/appointment-service';
import { AppointmentProcedure, PatientAppointment } from '../../../../../../../services/appointment/types';
import { Card, CardTitle } from '../../../../../../shared/card/card.style';
import { Dialog } from '../../../../../../shared/dialog/dialog.styles';
import { CloseDialogButton, DialogContentWrapper } from './procedures-dialog.styles';
import { ProceduresTable } from './procedures-table/procedures-table';

export interface ProceduresDialogProps {
  isOpen: boolean;
  appointment: PatientAppointment;
  onClose: () => void;
}

export const ProceduresDialog: FC<ProceduresDialogProps> = (props) => {
  const { isOpen, appointment, onClose } = props;
  const { config } = useConfig();
  const { oidcService } = useOidcWithAdmin();
  const { showError } = useNotification();
  const { contactDetails, locationId } = usePatientProfile();
  const [isLoading, setIsLoading] = useState(false);
  const [procedures, setProcedures] = useState<AppointmentProcedure[]>([]);
  const appointmentService = useMemo(() => new AppointmentService(config, oidcService), [config, oidcService]);

  useEffect(() => {
    if (!isOpen) return;
    loadProcedures();
  }, [isOpen]);

  const loadProcedures = async () => {
    try {
      setIsLoading(true);
      const proc = await appointmentService.getAppointmentProcedures(appointment.id, locationId);
      setProcedures(proc);
    } catch {
      showError('Unable to load appointment procedures');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Dialog open={isOpen} maxWidth={false}>
      <DialogContentWrapper>
        <DialogTitle sx={{ cursor: 'default' }}>
          {contactDetails.firstName} {contactDetails.lastName}
          <CloseDialogButton onClick={onClose} />
        </DialogTitle>
        <DialogContent>
          <Card>
            <CardContent>
              <CardTitle sx={{ paddingLeft: '5px' }}>
                Procedures ({moment(appointment.date).format('MM/DD/YYYY')})
              </CardTitle>
              <ProceduresTable procedures={procedures} isLoading={isLoading} />
            </CardContent>
          </Card>
        </DialogContent>
      </DialogContentWrapper>
    </Dialog>
  );
};
